<template>
  <section>
    <el-form :model="formObj" :rules="formRules" ref="formObj" label-width="120px">
      <el-form-item label="项目" v-if="proList.length>0" prop="proId">
        <el-select v-model="formObj.proId" placeholder="请选择项目" @change="proChange">
          <el-option v-for="(item,index) in proList" :key="item.id" :value="item.id" :label="item.proName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="名称" prop="progressName">
        <el-input v-model="formObj.progressName" placeholder="请输入名称" maxlength="20"  show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="时间" prop="time">
        <el-date-picker
          v-model="formObj.time"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="使用模型" prop="modelId">
        <el-select v-model="formObj.modelId" placeholder="使用模型">
          <el-option  v-for="(item,index) in tools" :key="item.id" :label="item.modelName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="doCancel">取消</el-button>
      <el-button type="primary" @click.native="doSubmit(option)">确定</el-button>
    </div>
  </section>
</template>

<script>
  import {proSearch,searchModel,updateProgress,createProgress,detailModel} from '../../api/api'
  export default {
    name: "ModelForm",
    props: {
      option: 0,
      formData:{},
      type:0
    },
    data(){
      return {
        formObj: {proId:null,modelId:null,time:null},
        formRules: {
          proId: [
            {required: true, message: '请选择项目', trigger: 'change'}
          ],
          progressName: [
            {required: true, message: '请输入计划名称', trigger: 'blur'}
          ],
          time: [
            {required: true, message: '请选择时间区间', trigger: 'change'}
          ],
          modelId:[
            {required: true, message: '请选择模型', trigger: 'change'}
          ],
        },
        fileList: [],
        tools:[],
        proList:[],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },

      }
    },
    methods:{
      doSubmit: function (option) {
        this.$refs.formObj.validate((valid) => {
          if (valid) {
            detailModel({id: this.formObj.modelId}, this.GLOBAL.header).then(result => {
              if (result.success) {
                if(result.data!=null){
                  this.formObj.modelName = result.data.modelName;
                }
                let rangTime = this.formObj.time + ''
                let beginTime = null, endTime = null;
                if (rangTime) {
                  beginTime = rangTime.split(',')[0]
                  beginTime = new Date(beginTime)
                  endTime = rangTime.split(',')[1]
                  endTime = new Date(endTime)
                }
                this.formObj.beginTime = beginTime
                this.formObj.endTime = endTime

                this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
                  if (option == 0) {
                    createProgress(this.formObj, this.GLOBAL.header).then(result => {
                      if (result.success) {
                        this.$message({
                          message: '创建成功',
                          type: 'success'
                        })
                        this.$emit('doSubmit');
                      }
                    });
                  }
                  else if (option == 1) {
                    updateProgress(this.formObj, this.GLOBAL.header).then(result => {
                      if (result.success) {
                        this.$message({
                          message: '修改成功',
                          type: 'success'
                        })
                        this.$emit('doSubmit');
                      }
                    });
                  }
                }).catch(() => {
                });
              }
            });

          }
        });


      },
      doCancel:function(){
        this.$emit('doCancel');
      },
      proChange:function(id){
        this.formObj.modelId = null;
        //初始化模型列表
        searchModel({proId:id,flag:1}, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.tools = result.data;
            if (this.option == 1) {
              this.formObj = this.formData;
              if(this.formObj.modelId==0){
                this.formObj.modelId = null;
              }
              let timeRange = [];
              timeRange.push(this.formObj.beginTime);
              timeRange.push(this.formObj.endTime);
              this.formObj.time = timeRange;
            }
          }
        });
      }
    },
    mounted() {
      //初始化表单数据
      if (this.option == 1) {
        this.proChange(this.formData.proId);
      }else {
        this.formObj = this.formData;
      }
      //加载项目列表 如果 当前用户没有在任何项目  那么 加载 该用户所在公司及下属公司的所有项目
      if (this.GLOBAL.proList.length > 0) {
        this.proList = this.GLOBAL.proList;
      }else {
        let params = {
          page: 1,
          limit: 10000,
          comId: this.GLOBAL.user.comId == '' ? null : this.GLOBAL.user.comId
        };//请求参数
        proSearch(params, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.proList = result.data.result;
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/progress/ProgressForm.vue